import React, { useState, useEffect } from "react";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, Card, Badge, DropdownItem, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, UncontrolledTooltip, Spinner } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    PaginationComponent,
    Row,
    Col,
    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableRow,
    DataTableItem,
} from "../../../components/Component";
import { Link } from "react-router-dom";
import { loginAxios } from '../../../config/axios.config';
import { useQuery, useMutation } from "@tanstack/react-query";
import { useSelector, useDispatch } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import { toastStyles } from "../../../utils/Utils";

const InvoiceExportListing = () => {

    const dispatch = useDispatch();

    const fileUploadMsg = useSelector((state) => state.commonReducer.fileUploadMsg);

    const [data, setData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [itemPerPage, setItemPerPage] = useState(20);
    const [totalCount, setTotalCount] = useState('');

    const paginate = (pageNumber) => setCurrentPage(pageNumber);




    const indexOfLastItem = currentPage * itemPerPage;
    const indexOfFirstItem = indexOfLastItem - itemPerPage;

    const userLoginDetails = JSON.parse(localStorage.getItem("userInitDetails"));



    const getList = () => {
        const indexOfLastItem = currentPage * itemPerPage;
        const indexOfFirstItem = indexOfLastItem - itemPerPage;

        var payload = {
            offsetItem: indexOfFirstItem,
            itemPerPage
        }

        refetchExportList.mutate(payload)        
    }

    useEffect(async () => {
        getList()

    }, [currentPage, itemPerPage]);


    // const getExportList = async (param) => {
    //     try {
    //         const { data } = await loginAxios.get(`designers/get_upload_product_report?offset=${param.offsetItem}&limit=${itemPerPage}`, {
    //             headers: {
    //                 'x-auth-token': localStorage.getItem('accessToken')
    //             }
    //         });
    //         return data;
    //     } catch (error) {
    //         return Promise.reject(error);
    //     }
    // };


    const getExportList = async (param) => {
        try {
            const { data } = await loginAxios.get(`designers/get_product_details_file?offset=${param.offsetItem}&limit=${param?.itemPerPage}&report_type=invoice`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const refetchExportList = useMutation(getExportList, {
        // refetchOnMount: false,
        // refetchOnWindowFocus: false,
        onSettled(data, error) {
            if (data) {
                console.log(data);
                console.log(data.data?.export_file_link_data);
                setData(data?.data?.export_file_link_data);
                setTotalCount(data.data?.total_count)
            }
        }
    })


    useEffect(() => {
        console.log(fileUploadMsg);

        if (fileUploadMsg?.status == true) {

            toast.success(fileUploadMsg?.msg, toastStyles);            

        } else if (fileUploadMsg?.status == false) {
            toast.error(fileUploadMsg?.msg, toastStyles);            
        }



    }, [fileUploadMsg]);




  const exportProducts = async (params) => {
    try {
      const { data } = await loginAxios.post(`payment/export_invoice`, params, {
        headers: {
          'x-auth-token': localStorage.getItem('accessToken')
        }
      });
      return data;

    } catch (error) {
      return Promise.reject(error);
    }
  };

  const exportProductsCall = useMutation(exportProducts, {
    onSettled(data, error) {
      if (data) {

        // console.log(data);

          toast.success(data?.data?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            progress: false,
          });

          getList();

      } else if (error) {
                
        console.log('found ERROR');

        toast.error(error.response?.data?.data, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          progress: false,
        });
      }      
    }
  });


  const handleExport = () => {
    exportProductsCall.mutate();    
  }

    return (<>

        {/* /bulk-update-add */}
        <Head title="Bulk Update"></Head>
        <Content>
            <BlockHead size="sm">
                <BlockBetween>
                    <BlockHeadContent>
                        <BlockTitle>Invoice Export</BlockTitle>


                        {userLoginDetails.profile_approval_status != "PENDING" &&

                            <div className="toggle-wrap nk-block-tools-toggle">
                                <div className="toggle-expand-content">
                                    <ul className="nk-block-tools g-3">

                                        <li className="nk-block-tools-opt">
                                            {/* <Link to='bulk-update-add'>
                                                <Button color="primary" className="btn-icon" id="addBtn">
                                                    <Icon name="plus"></Icon>
                                                </Button>
                                            </Link> */}


                                            <button className="btn btn-primary" onClick={handleExport} disabled={exportProductsCall.isLoading ? true : false}>
                                                {exportProductsCall.isLoading ? <Spinner color="light" size='sm' /> : <Icon name="download" />}
                                                <span>Invoice Export</span>
                                            </button>

                                        </li>

                                    </ul>
                                </div>
                            </div>
                        }

                    </BlockHeadContent>
                </BlockBetween>
            </BlockHead>

            <Block>
                <Card className="card-stretch">
                    <div className="card-inner-group">


                        <DataTable className="card-stretch">
                            <DataTableBody compact>
                                <DataTableHead>
                                    {/* <DataTableRow size="md">
                                        <span className="lead-text">ID</span>
                                    </DataTableRow> */}

                                    <DataTableRow size="md">
                                        <span className="lead-text">REQUEST ID</span>
                                    </DataTableRow>
                                    <DataTableRow size="lg">
                                        <span className="lead-text">INVOICE EXPORT FILE</span>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                        <span className="lead-text">STATUS</span>
                                    </DataTableRow>
                                    {/* <DataTableRow size="md">
                                        <span className="lead-text">COMMENTS</span>
                                    </DataTableRow> */}

                                    {/* <DataTableRow size="md">
                                        <span className="lead-text">ADDED BY</span>
                                    </DataTableRow> */}

                                    <DataTableRow size="md">
                                        <span className="lead-text">DATE ADDED</span>
                                    </DataTableRow>

                                </DataTableHead>




                                {data?.length > 0
                                    ? data?.map((item) => {
                                        return (
                                            <DataTableItem key={item.id}>

                                                <DataTableRow size="md">
                                                    <span>{item.id}</span>
                                                </DataTableRow>

                                                <DataTableRow size="lg">
                                                    {item.file_url ? <a href={item.file_url} download target="_blank" style={{ color: '#0000EE', display: 'inline-block', whiteSpace: 'nowrap', width: '400px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {`${item.file_url ? item.file_url : "Not Available "}`}
                                                    </a> : <span>Not Available</span>}
                                                    
                                                </DataTableRow>
                                                <DataTableRow size="sm">
                                                    <span>{item.status}</span>
                                                </DataTableRow>
                                                {/* <DataTableRow size="md">
                                                    <span>{item.comments}</span>
                                                </DataTableRow> */}
                                                {/* <DataTableRow size="md">
                                                    <a href={item.exception_file_url} download target="_blank" style={{ display: 'inline-block', whiteSpace: 'nowrap', width: '200px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {`${item.exception_file_url ? item.exception_file_url : "Not Available "}`}
                                                    </a>                                                    
                                                </DataTableRow> */}

                                                {/* <DataTableRow size="md">
                                                    <span>{item.added_by}</span>
                                                </DataTableRow> */}

                                                <DataTableRow size="md">

                                                    <span>{moment(item.created_at).format("YYYY-MM-DD HH:mm")}</span>
                                                </DataTableRow>

                                            </DataTableItem>
                                        );
                                    })
                                    : null}

                            </DataTableBody>

                            <div className="card-inner">
                                {data.length > 0 ? (
                                    <PaginationComponent
                                        itemPerPage={itemPerPage}
                                        totalItems={totalCount}
                                        paginate={paginate}
                                        currentPage={currentPage}
                                        setItemPerPage={setItemPerPage}
                                    />
                                ) : (
                                    <div className="text-center">
                                        <span className="text-silent">No data found</span>
                                    </div>
                                )}
                            </div>
                        </DataTable>

                    </div>
                </Card>
            </Block>
        </Content>
        <ToastContainer />
    </>)
};

export default InvoiceExportListing;